'use client';

import type { KeyVal, ProductInformation } from '@dealerportal/common';
import { useTranslations } from '@dealerportal/i18n/client';
import type { ChangeEventHandler, Dispatch, SetStateAction } from 'react';

export const SizeSelect = (props: {
  productInfo: ProductInformation;
  setSpecs: Dispatch<SetStateAction<KeyVal[]>>;
}) => {
  const t = useTranslations('products');
  const handleChange: ChangeEventHandler<HTMLSelectElement> = ({ target }) =>
    props.setSpecs((specs) => {
      const newSpecs = [...specs];
      const dimensionIndex = newSpecs.findIndex(
        (spec) => spec.key === 'Dimensions'
      );

      if (dimensionIndex !== -1) {
        newSpecs[dimensionIndex] = { key: 'Dimensions', value: target.value };
      } else {
        newSpecs.push({ key: 'Dimensions', value: target.value });
      }

      return newSpecs;
    });

  return (
    <div>
      {props.productInfo.sizes &&
        props.productInfo.sizes.filter((size) => size.Name).length > 0 && (
          <div>
            <div className="ui-font-semibold ui-text-sm ui-text-gray-500">
              {props.productInfo.sizes?.length > 1
                ? t('availableSizes')
                : t('availableSize')}
              :
              {props.productInfo.sizes?.length === 1 && (
                <span className="ui-font-normal ui-text-black">
                  {' '}
                  {props.productInfo.sizes[0].Name}
                </span>
              )}
            </div>

            {props.productInfo.sizes?.length > 1 && (
              <div className="ui-relative ui-mt-2">
                <select
                  className="ui-h-12 ui-w-full ui-border ui-border-gray-300 ui-rounded !ui-bg-white ui-p-3 ui-text-sm ui-leading-5 ui-appearance-none"
                  onChange={handleChange}
                >
                  {props.productInfo.sizes?.map((s) => (
                    <option key={s.SizeId}>{s.Name}</option>
                  ))}
                </select>
                <svg
                  className="ui-w-3 ui-absolute ui-right-3 ui-top-1/2 -ui-translate-y-1/2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    className="ui-fill-gray-500"
                    d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                  />
                </svg>
              </div>
            )}
          </div>
        )}
    </div>
  );
};
